<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FM-head1">Contents</h1>
<p class="toc"><a href="#/Introduction#Int">Introduction</a></p>
<p class="toc1"><a href="#/Part1#P1"><b>Techniques</b></a></p>
<p class="toc"><a href="#/Chapter1#C1">Understanding Macraweave</a></p>
<p class="toc"><a href="#/Chapter2#C2">Materials</a></p>
<p class="toc"><a href="#/Chapter3#C3">General Techniques</a></p>
<p class="toc"><a href="#/Chapter4#C4">The Knots</a></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">The Weaves</span></p>
<p class="toc1"><span href="#/Part2#P2" title="Link target outside of Sample"><b>Projects</b></span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">Keeper Key Rings</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">Vamp It Up Cushion Cover</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">Pendant Lampshade</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">Plant Cradle</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">Rainbow Arch Wall Hanging</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">Zigzag Belt</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">Feather Fray Earrings</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">Collar Necklace</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">Lots of Pots Plant Holder</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">Essentials Shoulder Bag</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">Give It a Whirl Coasters</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">Star Attraction Placemat</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">Handy Clutch Purse</span></p>
<p class="toc"><span href="#/Chapter19#C19" title="Link target outside of Sample">Woven Wheel Mirror</span></p>
<p class="toc"><span href="#/Chapter20#C20" title="Link target outside of Sample">Dress It Up Flower Vase</span></p>
<p class="toc"><span href="#/Chapter21#C21" title="Link target outside of Sample">Nursery Dream Catcher</span></p>
<p class="toc"><span href="#/Chapter22#C22" title="Link target outside of Sample">Reimagined Director’s Chair</span></p>
<p class="toc"><span href="#/Chapter23#C23" title="Link target outside of Sample">Pride and Joy Wall Hanging</span></p>
<p class="toc1"><span href="#/Author#Aut" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?e8de2ebc